import { baseConfig } from '@adornis/config/baseConfig';
import type { TrackerInput } from './types/Tracker';

export const getZohoOptions = (): TrackerInput => ({
  identifier: 'zoho-tracking',
  scripts: [getScript()],
});

export function trackCurrentPage() {
  const config = getZohoTrackingConfig();

  try {
    // @ts-expect-error should exist for unknown reasons
    loadwaprops(...config, '0.0');
  } catch (e) {
    console.error('Zoho tracking failed', e);
  }
}

function getZohoTrackingConfig(): string[] {
  const rootURL = baseConfig.get('ROOT_URL');
  const configMap = {
    'https://digitale-helden-prelaunch-marketing.staging.adornis.de/': [
      '3z23973f85cc7c82047d6e520407459a6f',
      '3z5b6491340b2218515247437476639dd5',
      '3z6c91fdb2d1b6592f33c30e9ddc28fa77543d384c5467124386b5953f0ac544d7',
      '3zfea534827b6bea133a4af2cc1a9b367ccb492d66dfaa1a69252d2d4572750ca2c5417a0a4187a9529f29165f130db5aea708ddfda2f5219841f2e36b9c1732e7',
    ],
    'https://digitale-helden-campus.staging.adornis.de/': [
      '3z23973f85cc7c82047d6e520407459a6f',
      '3z5b6491340b2218515247437476639dd5',
      '3z6c91fdb2d1b6592f33c30e9ddc28fa771039f27f7d1f3ca037869dc044a13eaa',
      '3zfea534827b6bea133a4af2cc1a9b367c5fbc6d73e4e0919f8f60a0baf34ec5548d161ce87265e14441eca59fda1cc805',
    ],
    'https://digitale-helden.de/': [
      '3z23973f85cc7c82047d6e520407459a6f',
      '3z5b6491340b2218515247437476639dd5',
      '3ze86f4e1ed6fd4a321176ff3d3891eb859976ec36506ff1927e7df3ac2042e504',
      '3z778154cc65ad0f993bd44b0970c456d5ee060f4831ef11f2f1c16d1c30520bad',
    ],
    'https://campus.digitale-helden.de/': [
      '3z23973f85cc7c82047d6e520407459a6f',
      '3z5b6491340b2218515247437476639dd5',
      '3z6c91fdb2d1b6592f33c30e9ddc28fa77e573adb39a1392f241414c800758ed44',
      '3z3648f8e46ecdbb1e403b792c0026c66b42a4857a4831b39546a0551cecdf96fb',
    ],
    'https://lasdigitale-helden-michi-campus-runtime.nexus.adornis.de/': [
      '3z23973f85cc7c82047d6e520407459a6f',
      '3zbb0e02aa52f6c237e4d5a23bbc9d12f7',
      '3zb92a94884aa065c038f935a04701143f7f101ab490ac6b46ef224460158e633d',
      '3zce8bb359a1b1e25e5df6b918d0637e02f39a2ff17bb65a6aae8ef61c89c67333d91e19c84399e1ccad28b1f3956b8add77ebd0688ac6e9011d339477aa1144ec',
    ],
  };

  const config = configMap[rootURL];
  if (!config) {
    throw new Error(`No Zoho tracking script defined for URL '${rootURL}'`);
  }

  return config;
}

function getScript() {
  const script = document.createElement('script');
  script.src = 'https://ma.zoho.eu/hub/js/WebsiteAutomation.js?nocache=' + Date.now();
  return script;
}
